/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import type {
  ArgGetItemInspectionResult,
  ResGetItemInspectionResult
} from '@/types/api/emergencyInspectionResult/emergencyInspectionResult'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import { ERROR_MESSAGES } from '@/constants/error/errorMessage'
import { ERROR_CODES } from '@/constants/error/errorCode'

/**
 * 応急危険度判定の調査実施結果API（get）を実行する
 * @param arg リクエストパラメータ
 * @returns レスポンスまたはエラーメッセージ
 */
export const getEmergencyInspectionResult = async (
  arg: ArgGetItemInspectionResult
): Promise<ResGetItemInspectionResult> => {
  return await new Promise((resolve, reject) => {
    useApiGw().invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointEmergency,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/emergencyInspectionResult',
      // Lambda関数に渡す引数
      {
        function: 'get',
        params: arg
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (response: ResGetItemInspectionResult) => {
        resolve(response)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      (message: any) => {
        reject({ message: message })
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        reject({ message: ERROR_MESSAGES[ERROR_CODES.API_EXECUTION_FAILED].message })
      },
      // 処理完了後に実行するコールバック
      () => {},
      // ローディング画面を表示するかどうか
      false
    )
  })
}
